import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/Arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-f16ee910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "find__people_cont" }
const _hoisted_2 = { class: "find__people_flex" }
const _hoisted_3 = { class: "find__people_text" }
const _hoisted_4 = { class: "find__people_link" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Arrow"
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "foundation_cont"
}
const _hoisted_7 = {
  key: 1,
  class: "preloader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layout_elements_vacancies = _resolveComponent("layout-elements-vacancies")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.getStaticLanguage.textFindPeople), 1),
      _createVNode(_component_router_link, {
        to: "/vacancies",
        class: "find__people_a"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.getStaticLanguage.viewVacancies), 1),
            _hoisted_5
          ])
        ]),
        _: 1
      })
    ]),
    (!_ctx.getProcessV)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_layout_elements_vacancies, {
            items: _ctx.activeVacancies,
            setVacan: _ctx.setVacan,
            setModal: _ctx.setModal
          }, null, 8, ["items", "setVacan", "setModal"])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_7))
  ]))
}